import { preview } from '@/components/form/preview'
import { useOrderViolationTexts } from '@/intl'
import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function BannedTags(props: Props) {
  const { extOrder } = props
  const { getViolationText } = useOrderViolationTexts()
  const texts = useTexts()

  const hasViolations = extOrder.isUnassigned ? false : extOrder.violations?.includes('TGO')
  const tagsCount = extOrder.orderStep.tagsOut.length

  return (
    <preview.Field label={texts.bannedTags.label(tagsCount)} variant="alternative">
      <preview.ViolationContainer
        violation={
          hasViolations ? <preview.ViolationBadge tooltip={getViolationText('TGO')} /> : null
        }
      >
        <preview.TagsList tags={extOrder.orderStep.tagsOut} maxHeightPx={48} />
      </preview.ViolationContainer>
    </preview.Field>
  )
}
